import { Additional, ReactSelect, ReactSelectProps } from "../ReactSelect";

import { useApi } from "@/hooks/useApi";
import { transformData } from "@/utils/transformData";
import { paginatedSurgicalAttendanceMap } from "@/utils/mappings/surgicalAttendance";

type Props = ReactSelectProps;

type PaginatedSurgicalAttendances = TransformedGenericPagination<SurgicalAttendance>;

export function PatientsSelect({ ...rest }: Props) {
	const { api } = useApi();

	async function getSurgicalAttendances(page: number, search: string) {
		try {
			const { data } = await api.get("surgical-center/surgical-attendances", {
				params: { page, search },
			});

			const transformedData = transformData<PaginatedSurgicalAttendances>(
				data,
				paginatedSurgicalAttendanceMap
			);

			return transformedData;
		} catch (error) {
			console.log(error);
			return {} as PaginatedSurgicalAttendances;
		}
	}

	const loadAsyncPatientOptionsProps = {
		additional: { page: 1 },
		isAsyncPaginate: true,
		async loadOptions(search: string, _: SurgicalAttendance, { page }: Additional) {
			const surgicalAttendances = await getSurgicalAttendances(page, search);
			const meta = surgicalAttendances.meta;

			return {
				options: surgicalAttendances?.results.map((surgicalAttendance) => ({
					value: surgicalAttendance.id,
					attendance_id: surgicalAttendance.attendanceId,
					id: surgicalAttendance.id,
					expertise: {
						id: surgicalAttendance.expertiseId,
						name: surgicalAttendance.expertise.name,
					},
					label: surgicalAttendance.patient.name,
				})),
				hasMore: meta?.currentPage < meta?.lastPage,
				additional: { page: page + 1 },
			};
		},
	};

	return <ReactSelect isSolid {...loadAsyncPatientOptionsProps} {...rest} />;
}
